import { render, staticRenderFns } from "./ProspectInviteNew.vue?vue&type=template&id=582a4a2b&"
import script from "./ProspectInviteNew.vue?vue&type=script&lang=js&"
export * from "./ProspectInviteNew.vue?vue&type=script&lang=js&"
import style0 from "./ProspectInviteNew.vue?vue&type=style&index=0&id=582a4a2b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports